import React, { useState } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { NavLink, useNavigate } from 'react-router';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import Pagination from '../../../components/base/Pagination/Pagination';
import { geographyColumns } from './geographyColumns';
import ExportDialog from './ExportDialog';
import ImportDialog from './ImportDialog';
import { dateFormatter } from '../../../utils/formatters';

export default function GeographyList(props) {
  const {
    handleCreate = () => {},
    handleEdit = () => {},
    handleDelete = () => {},
    handleSelect = () => {},
    handleImport = () => {},
    handleExport = () => {},
    loadData = () => {},
    selected = null,
    geographyListMeta = {},
    geographyList = [],
    control,
  } = props;
  const [showExport, setShowExport] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const handleClose = item => {
    setShowImport(false);
    setShowExport(false);
  };

  return (
    <div className="list-columns card py-3">
      <div className="list-header px-3">
        <div className="fs-5 fw-semibold ">{formatMessage({ id: 'menu.geography' })}</div>
        <Button className="small-button ms-auto" variant="second" onClick={() => setShowImport(true)}>
          <Icons icon="journal-arrow-up" />
        </Button>
        <Button className="small-button ms-2" variant="second" onClick={handleExport}>
          <Icons icon="journal-arrow-down" />
        </Button>
        <Button className="small-button ms-2" variant="second" onClick={handleCreate}>
          <Icons customIcon icon="plus" />
        </Button>
      </div>
      <div className="filter-row px-3 mt-3">
        <FieldDTO
          control={control}
          component={TextInput}
          dtoObject={{
            name: 'search',
            type: String,
            labelKey: 'search',
          }}
          className="no-border"
          inputBefore={(
            <div className="search-wrapper">
              <Icons customIcon className="search" width={24} height={24} icon="search" />
            </div>
          )}
        />
      </div>
      <div className="list-content-wrapper">
        <div className="list-content-body custom-scroll-theme list-group list-group-flush border-bottom">
          {geographyList.map((geography, key) => (
            <div
              key={key}
              className={classNames('list-group-item list-group-item-action py-3 lh-sm pointer', { active: geography.geography_id === selected })}
              onClick={handleSelect(geography)}
            >
              <div className="d-flex w-100 align-items-center justify-content-between">
                <div className="d-flex flex-row col-xxl-12">
                  <div className="list-item-name"><strong className="mb-1">{geography?.name || ''}</strong></div>
                  <div className="geography-button-block d-flex flex-row ms-auto">
                    <div className="geography-capacity"><small>{geography?.capacity || ''}</small></div>
                    {/* <Button className="small-button" variant="second" onClick={() => window.open(`/geography/history?geography_id=${geography.geography_id}`, '_blank')}> */}
                    {/*  <Icons icon="info-lg" /> */}
                    {/* </Button> */}
                    <Button className="small-button ms-1" variant="second" onClick={handleEdit(geography)}>
                      <Icons icon="pencil" />
                    </Button>
                    <Button className="small-button red-hover ms-1" variant="second" onClick={handleDelete(geography)}>
                      <Icons icon="trash" />
                    </Button>
                  </div>
                </div>
              </div>
              <div className="w-100 mb-1 mt-1 small">{geography?.description || ''}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="list-footer px-3">
        <Pagination meta={geographyListMeta} list={geographyList} handleChangeMeta={loadData} />
      </div>
      {showExport ? <ExportDialog onClose={handleClose} loadData={loadData} handleExport={handleExport} columns={geographyColumns} /> : null}
      {showImport ? <ImportDialog onClose={handleClose} loadData={loadData} handleImport={handleImport} /> : null}
    </div>
  );
}
